module.exports = __webpack_public_path__ + "static/img/Opportunities_EnjoyingLA_Movie_Theaters.2256be4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Opportunities_EnjoyingLA_Movie_Theaters.jpg
// module id = Afi4
// module chunks = 1